/** @format */
import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { configDefault } from '../../core/config';
import { useDispatch } from 'react-redux';
import { prefixesConstants } from '../../modules/prefixes/reducers';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import PrefixAdd from './PrefixAdd';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { useParams } from 'react-router-dom';
import PrefixInterface from '../../interfaces/billing/PrefixInterface';
import { PrefixPricelistList } from './PrefixPricelistList';
import CardHeader from '../../components/Heading/CardHeaderExt';
import Card from '../../components/Card/Card';
import CardBody from '../../components/Card/CardBody';

interface PrefixAddProps {
    prefix?: PrefixInterface;
}

export const PrefixEdit = (props: PrefixAddProps): React.ReactElement => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [item, setItem] = useState<PrefixInterface | null>(null);

    const URI = '/prefixes';

    useEffect(() => {
        if (id) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`${URI}/${id}`, configDefault.PLATFORM_API_PREFIX)),
                prefixesConstants.ITEM,
                (data: PrefixInterface) => {
                    setItem(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        }
    }, [dispatch, id]);

    return (
        <GridContainer spacing={2}>
            {!item ? (
                <div>Ładowanie</div>
            ) : (
                <React.Fragment>
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader trans="prefixes:h.prefix_edit" />
                            <CardBody>
                                <PrefixAdd prefix={item} editMode={true} />
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader trans="prefixes:h.prefix_pricelist_assigned" />
                            <CardBody>
                                <GridItem xs={8}>
                                    <PrefixPricelistList />
                                </GridItem>
                            </CardBody>
                        </Card>
                    </GridItem>
                </React.Fragment>
            )}
        </GridContainer>
    );
};
